import { useMsal } from '@azure/msal-react'
import { loginRequest } from '../auth/authConfig'

function LoginPage() {
    const { instance } = useMsal()

    const handleLogin = () => {
        instance.loginRedirect(loginRequest)
    }

    return (
        <div className="min-h-screen bg-gradient-to-br from-slate-950 via-blue-950 to-slate-950 flex items-center justify-center">
            <div className="text-center space-y-8">
                <div>
                    <img
                        src="/aviator-energy-design.png"
                        alt="Aviator Energy"
                        className="h-24 mx-auto mb-6"
                    />
                    <h1 className="text-3xl font-bold text-white">Daily Dashboard</h1>
                    <p className="text-blue-300 mt-2">Operations Analytics</p>
                </div>
                <button
                    onClick={handleLogin}
                    className="bg-blue-700 hover:bg-blue-600 text-white px-8 py-3 rounded-lg font-medium text-lg transition shadow-lg"
                >
                    Sign In with Microsoft
                </button>
                <p className="text-gray-500 text-sm">Internal use only</p>
            </div>
        </div>
    )
}

export default LoginPage
